import welcomeTasksData from '../data/welcome-tasks.json';
import constants from '../utils/constants';

// Process welcome tasks to replace download URL with constants
const welcomeTasks = {
  tasks: welcomeTasksData.tasks.map((task) => {
    if (task.id === 'download' && task.action?.href) {
      return {
        ...task,
        action: {
          ...task.action,
          href: constants.DOWNLOAD_URL_MACOS
        }
      };
    }
    return task;
  })
};

export { welcomeTasks };

import { createStoreHandle } from '../utils/store.util';
const FILENAME = 'welcome-tasks.dat';

export type WelcomeTask = (typeof welcomeTasks.tasks)[number];

type WelcomeTaskState = Record<WelcomeTask['id'], boolean>;

const taskStates: WelcomeTaskState = Object.fromEntries(
  welcomeTasks.tasks.map((task) => [task.id, task.checked ?? false])
);

export const {
  store: welcomeTasksModel,
  itemStore: welcomeTasksStore,
  setItem: setWelcomeTasks,
  resetItem: resetWelcomeTasks,
  loadStoredItem: loadWelcomeTasks,
  scheduleUpdate: scheduleWelcomeTasksUpdate
} = createStoreHandle<WelcomeTaskState>(FILENAME, taskStates);
